import API from "./axios";

const grnApi = {
  getAll:         ()             => API.get("/grn"),
  /** Phase 5 — paged register. params: { page, size, sortBy, sortDir, q, status, poId, vendorId } */
  paged:          (params)       => API.get("/grn/paged", { params }),
  getById:        (id)           => API.get(`/grn/${id}`),
  getByPo:        (poId)         => API.get(`/grn/po/${poId}`),
  create:         (data)         => API.post("/grn", data),
  // Phase 36da.99.gra — upload GRN attachment (sub-vendor invoice / LR; photo/PDF). Returns { path, url }.
  uploadAttachment: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return API.post("/grn/upload-attachment", fd, {
      headers: { "Content-Type": undefined },
    });
  },
  update:         (id, data)     => API.put(`/grn/${id}`, data),
  confirm:        (id)           => API.patch(`/grn/${id}/confirm`),
  // Take a CONFIRMED GRN back to DRAFT: undoes PO receipt, stock, ledgers and
  // bale opening. Refused while anything still uses its goods.
  revert:         (id)           => API.patch(`/grn/${id}/revert`),
  delete:         (id)           => API.delete(`/grn/${id}`),
  // Phase 36da.99.grndelc — delete a CONFIRMED (unbilled, unconsumed) GRN; reverses stock + PO + ledgers.
  deleteConfirmed:(id)           => API.delete(`/grn/${id}/confirmed`),
  updateInfo:     (id, data)     => API.patch(`/grn/${id}/info`, data),
  downloadPdf:    (id)           => API.get(`/grn/${id}/pdf`, { responseType: "blob" }),
  // Phase 36da.99.grnref — direct-to-disk download.  Same PDF, but the server sends
  // Content-Disposition: attachment with the filename "{GRN} {variant codes}.pdf",
  // so it lands in Downloads already named instead of opening in a tab.
  downloadPdfToDisk: (id)        => API.get(`/grn/${id}/pdf/download`, { responseType: "blob" }),
  // Phase 36da.99.dt — full GRN report exports. params: { q, status, fromDate, toDate }
  reportExcel:    (params)       => API.get("/grn/report/excel", { params, responseType: "blob" }),
  reportPdf:      (params)       => API.get("/grn/report/pdf", { params, responseType: "blob" }),
  getUnopenedBales: ()           => API.get("/grn/bales/unopened"),
  /** Phase 36da.99.baleopen — paged + searchable unopened bales. params: { page, size, sortBy, sortDir, q } */
  unopenedBalesPaged: (params)   => API.get("/grn/bales/unopened/paged", { params }),
  openBale:       (baleId, data) => API.post(`/grn/bales/${baleId}/open`, data),
  getLumpByBarcode:    (barcode) => API.get(`/grn/lumps/barcode/${barcode}`),
  getBaleByBarcode:    (barcode) => API.get(`/grn/bales/barcode/${encodeURIComponent(barcode)}`),
  getLumpStockByBarcode:(barcode) => API.get(`/grn/lumps/barcode/${encodeURIComponent(barcode)}/stock`),
};

export default grnApi